import type React from 'react';

import { Separator } from '@change-corgi/design-system-legacy/components/content';
import { Icon } from '@change-corgi/design-system-legacy/components/icon';
import { iconAutoAwesome } from '@change-corgi/design-system-legacy/icons';
import { Box } from '@change-corgi/design-system-legacy/layout';
import { Text } from '@change-corgi/design-system-legacy/typography';

type TargetPetitionAssociationData = Readonly<{
	isAutoAdded: boolean | null;
	addedToPetitionAt: string | null;
	daysSinceNotified: number | null;
}>;

type Props = Readonly<{
	targetPetitionAssociationData: TargetPetitionAssociationData | null;
}>;

export const AutoAddLabel: React.FC<Props> = ({ targetPetitionAssociationData }) => {
	const isAutoAdded = !!targetPetitionAssociationData?.isAutoAdded;
	const addedToPetitionAt = targetPetitionAssociationData?.addedToPetitionAt
		? new Date(targetPetitionAssociationData.addedToPetitionAt).toLocaleDateString('en-US', {
				year: 'numeric',
				month: 'long',
				day: 'numeric',
			})
		: null;

	return isAutoAdded ? (
		<Box data-testid="autoadd-label">
			<Separator role="presentation" mt={8} sx={{ color: 'neutral-grey100' }} />
			<Icon as="div" icon={iconAutoAwesome} size="s" mr={4} />
			<Text size="micro">Automatically added on {addedToPetitionAt}</Text>
		</Box>
	) : null;
};
